import { type ProfileClusterForClient } from "common";
import { type JSX } from "react";
import { type UseFormRegister } from "react-hook-form";

export const variablesCardSummary = (params: {
  variable?: string | null;
  bashVariable?: string | null;
  runCommand?: string | null;
}): string => {
  const set = [params.variable, params.bashVariable, params.runCommand].filter(
    value => value?.trim()
  ).length;
  return set === 0 ? "None set" : `${set} set`;
};

export function VariablesCard({
  register,
  showRunCommand,
}: {
  register: UseFormRegister<ProfileClusterForClient>;
  showRunCommand: boolean;
}): JSX.Element {
  return (
    <>
      <div>
        <label className="block text-sm font-medium leading-6 text-gray-900">
          Profile Variables
        </label>
        <div className="mt-2">
          <textarea
            {...register("variable")}
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            placeholder="Your Profile Variables"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium leading-6 text-gray-900">
          Environment Variables
        </label>
        <div className="mt-2">
          <textarea
            {...register("bashVariable")}
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            placeholder="Your Environment Variables"
          />
        </div>
      </div>
      {showRunCommand && (
        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">
            Run Command
          </label>
          <div className="mt-2">
            <textarea
              {...register("runCommand")}
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              placeholder="Enter Run Commands"
            />
          </div>
        </div>
      )}
    </>
  );
}
